import React, { useEffect, useRef, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, STATUS, WHITE } from "../../appConstants";
import {
  Button,
  Input,
  Option,
  Select,
  selectClasses,
  Skeleton,
} from "@mui/joy";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import PlatformDashboardMappingEdit from "./PlatformDashboardMappingEdit";
import BrandPlatformEditModal from "./BrandPlatformEditModal";
import RemovePlatformModal from "./RemovePlatformModal";
import { set } from "lodash";
import RemoveDashboardModal from "./RemoveDashboardModal";
import appError from "../../appError";
import toast from "react-hot-toast";
import SaveChangesModal from "./SaveChangesModal";

type BrandPlatform = {
  platform: string;
  platform_id: string;
  platform_logo_url: string;
};

type Brand = {
  brand_id: string;
  brand_name: string;
  company_name: string;
  status: string;
  platform_array: BrandPlatform[];
};

type Dashboard = {
  brand_power_bi_dashboard_id?: string;
  brand_power_bi_dashboard_type_id: string;
  dashboard_type: string;
  workspace_id: string;
  report_id: string;
  color: string;
  dataset_id: string;
};

type SuggestPlatform = {
  platform: string;
  platform_id: string;
};

type PlatformDashboardMapping = {
  platform_id: string;
  platform: string;
  platform_logo_url: string;
  dashboard_array: Dashboard[];
};

type RemovePlatformModalDetailToggle = {
  toggle: boolean;
  platform_id: string;
  platform_logo_url: string;
  platform: string;
};

type RemoveDashboardModalDetailToggle = {
  toggle: boolean;
  dashboardTypeId: string;
  platformId: string;
  dashboard_type: string;
};

const BrandDetailEdit: React.FC = () => {
  const { brand_id } = useParams<{ brand_id: string }>();
  const navigate = useNavigate();

  const [
    dataBrandPlatformMappingFetchingState,
    setDataBrandPlatformMappingFetchingState,
  ] = useState<string>("LOADING");
  const [
    dataPlatformDashboardMappingFetchingState,
    setDataPlatformDashboardMappingFetchingState,
  ] = useState<string>("LOADING");

  const [brandPlatformMapping, setBrandPlatformMapping] = useState<Brand>({
    platform_array: [],
    brand_id: "",
    brand_name: "",
    company_name: "",
    status: "",
  } as Brand);
  const [platformDashboardMapping, setPlatformDashboardMapping] =
    useState<PlatformDashboardMapping[]>();
  const [addPlatformModalToggle, setAddPlatformModalToggle] =
    useState<boolean>(false);
  const [saveToggle, setSaveToggle] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [platformlength, setPlatformlength] = useState<number>(0);
  const [removePlatformModalDetailToggle, setRemovePlatformModalDetailToggle] =
    useState<RemovePlatformModalDetailToggle>({
      toggle: false,
      platform_id: "",
      platform_logo_url:"",
      platform: "",
    });

  const [
    removeDashboardModalDetailToggle,
    setRemoveDashboardModalDetailToggle,
  ] = useState<RemoveDashboardModalDetailToggle>({
    toggle: false,
    dashboardTypeId: "",
    platformId: "",
    dashboard_type: "",
  });

  
  useEffect(() => {
    fetchBrandPlatformMapping();
    fetchPlatformDashboardMapping();
  }, []);

  const onCancelClickHandler = () => {
    setSaveToggle(false);
    fetchBrandPlatformMapping();
    fetchPlatformDashboardMapping();
  };

  const fetchBrandPlatformMapping = async () => {
    setDataBrandPlatformMappingFetchingState("LOADING");

    const token = localStorage.getItem("token");

    let api = `${BASE_URL}brand/brandPlatformMapping?brand_id=${brand_id}`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, { headers });
      const { brand_platform_mapping } = result?.data?.data;

      if (!brand_platform_mapping) {
        setDataBrandPlatformMappingFetchingState("ERROR");
      } else {
        setDataBrandPlatformMappingFetchingState("SUCCESS");
        setBrandPlatformMapping(brand_platform_mapping);
      }
    } catch (error) {
    } finally {
    }
  };

  // useEffect(() => {}, []);
  const fetchPlatformDashboardMapping = async () => {
    const token = localStorage.getItem("token");
    setDataPlatformDashboardMappingFetchingState("LOADING");
    let api = `${BASE_URL}brand/platformDashboardMapping?brand_id=${brand_id}`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, { headers });
      const { platform_dashboard_mapping_array } = result?.data?.data;
      if (!platform_dashboard_mapping_array.length) {
        setDataPlatformDashboardMappingFetchingState("EMPTY");
      } else {
        setDataPlatformDashboardMappingFetchingState("SUCCESS");
        setPlatformDashboardMapping(platform_dashboard_mapping_array);
      }
    } catch (error) {
    } finally {
    }
  };

  const fetchSuggestPlatform = async () => {
    const token = localStorage.getItem("token");
    let api = `${BASE_URL}onboarding/platforms`;
    const headers = {
        "Authorization": `Bearer ${token}`
    }
    try {
        const result = await axios.get(api, { headers });
        const { platform_array: platformArray } = result?.data?.data;
        const platformMap = new Map<string, boolean>();
        brandPlatformMapping?.platform_array?.forEach((platform) => {
          platformMap.set(platform?.platform_id, true);
        });
        const filteredData : SuggestPlatform[] = platformArray.filter((p : SuggestPlatform)=> !platformMap.get(p?.platform_id));
        setPlatformlength(filteredData.length);
    } catch (error) {

    } finally {

    }
  }


  useEffect(()=>{
    fetchSuggestPlatform();
  },[platformDashboardMapping?.length]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBrandPlatformMapping((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setSaveToggle(true);
  };

  const onSelectChangeHandler = (event: any, value: any) => {
    setBrandPlatformMapping((prev) => {
      return {
        ...prev,
        status: value,
      };
    });

    setSaveToggle(true);
  };

  const addPlatform = async (platform_array: BrandPlatform[]) => {
    if (!platform_array.length) {
      return;
    }
    let platform_array_copy: PlatformDashboardMapping[] = platform_array.map(
      (platform) => {
        return {
          platform_id: platform.platform_id,
          platform: platform.platform,
          platform_logo_url:platform.platform_logo_url,
          dashboard_array: [],
        };
      }
    );
    setPlatformDashboardMapping((prev) => {
      if (!prev) {
        return platform_array_copy;
      }
      return [...platform_array_copy, ...prev];
    });
    setBrandPlatformMapping((prev) => {
      return {
        ...prev,
        platform_array: [...prev?.platform_array, ...platform_array],
      };
    });
    setDataPlatformDashboardMappingFetchingState("SUCCESS");
    setAddPlatformModalToggle(false);

    // if (containerRef.current) {
    //     containerRef.current.scrollTop = containerRef.current?.scrollHeight;
    // }
    setSaveToggle(true);
  };

  const addNewDashboard = (dashboard: Dashboard, platformId: string) => {
    setPlatformDashboardMapping((prev) => {
      const platformDashboardMapping = prev?.find(
        (platformDashboardMapping) =>
          platformDashboardMapping.platform_id === platformId
      );
      if (!platformDashboardMapping) {
        return prev;
      }
      return prev?.map((platformDashboardMapping) => {
        if (platformDashboardMapping.platform_id === platformId) {
          return {
            ...platformDashboardMapping,
            dashboard_array: [
              ...platformDashboardMapping.dashboard_array,
              dashboard,
            ],
          };
        }
        return platformDashboardMapping;
      });
    });
    setSaveToggle(true);
  };

  const removeDashboard = (
    dashboardTypeId: string,
    dashboard_type: string,
    platformId: string
  ) => {
    setRemoveDashboardModalDetailToggle({
      toggle: true,
      dashboardTypeId,
      platformId,
      dashboard_type,
    });
  };

  const removeDashboardFromState = () => {
    const { dashboardTypeId, platformId } = removeDashboardModalDetailToggle;
    setPlatformDashboardMapping((prev) => {
      return prev?.map((platformDashboardMapping) => {
        if (platformDashboardMapping.platform_id === platformId) {
          return {
            ...platformDashboardMapping,
            dashboard_array: platformDashboardMapping.dashboard_array.filter(
              (dashboard) =>
                dashboard.brand_power_bi_dashboard_type_id !== dashboardTypeId
            ),
          };
        }
        return platformDashboardMapping;
      });
    });

    setRemoveDashboardModalDetailToggle({
      toggle: false,
      dashboardTypeId: "",
      platformId: "",
      dashboard_type: "",
    });
    setSaveToggle(true);
  };
  const cancelRemoveDashboardToggle = () => {
    setRemoveDashboardModalDetailToggle({
      toggle: false,
      dashboardTypeId: "",
      platformId: "",
      dashboard_type: "",
    });
  };

  const editDashboard = (
    name: string,
    value: string,
    dashboardTypeId: string,
    platformId: string
  ) => {
    setPlatformDashboardMapping((prev) => {
      const platformDashboardMapping = prev?.find(
        (platformDashboardMapping) =>
          platformDashboardMapping.platform_id === platformId
      );
      if (!platformDashboardMapping) {
        return prev;
      }
      return prev?.map((platformDashboardMapping) => {
        if (platformDashboardMapping.platform_id === platformId) {
          return {
            ...platformDashboardMapping,
            dashboard_array: platformDashboardMapping.dashboard_array.map(
              (dashboard) => {
                if (
                  dashboard.brand_power_bi_dashboard_type_id === dashboardTypeId
                ) {
                  return {
                    ...dashboard,
                    [name]: value,
                  };
                }
                return dashboard;
              }
            ),
          };
        }
        return platformDashboardMapping;
      });
    });
    setSaveToggle(true);
  };

  const onSaveClickHandler = async () => {
    const { brand_id, brand_name, company_name, status } = brandPlatformMapping;
    const platform_array = platformDashboardMapping?.map(
      (platformDashboard) => {
        return {
          platform_id: platformDashboard.platform_id,
          platform_dashboard_mapping: platformDashboard.dashboard_array.map(
            (dashboard) => {
              return {
                brand_power_bi_dashboard_type_id:
                  dashboard.brand_power_bi_dashboard_type_id,
                workspace_id: dashboard.workspace_id,
                report_id: dashboard.report_id,
                dataset_id: dashboard.dataset_id
              };
            }
          ),
        };
      }
    );
    const payload = {
      brand_id,
      brand_name,
      company_name,
      status,
      platform_array,
    };
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let api = `${BASE_URL}brand/putBrandPlatformDashboardMapping`;
    try {
      setLoading(true);
      const result = await axios.put(api, payload, { headers });

      toast.success("Brand Details Updated Successfully");
      // if (result?.data?.status === "success") {

      // }
      setSaveToggle(false);
      fetchBrandPlatformMapping();
      fetchPlatformDashboardMapping();
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const removePlatformToggle = (platform: BrandPlatform, toggle: boolean) => {
    setRemovePlatformModalDetailToggle({
      toggle,
      platform_id: platform.platform_id,
      platform_logo_url: platform.platform_logo_url,
      platform: platform.platform,
    });
    // fetchSuggestPlatform();
  };

  const cancelRemovePlatformToggle = () => {
    setRemovePlatformModalDetailToggle({
      toggle: false,
      platform_id: "",
      platform_logo_url:"",
      platform: "",
    });
  };
  // const [DataChanged, setDataChanged] = useState<boolean>(false); //Check if Data has been Changed or Not
  const [cancelToggle, setCancelToggle] = useState<boolean>(false);
  const [navpath, setNavpath] = useState<string>("");

  const cancelToggleHandler = (path: string) => {
    if (saveToggle && path !== "brandList") {
      setNavpath("brandDetailView");
      setCancelToggle(true);
    } else if (saveToggle && path === "brandList") {
      setNavpath("brandList");
      setCancelToggle(true);
    } else if (path === "brandDetailView") {
      setNavpath(path);
      navigate(`/brandManagement/brandDetailView/${brand_id}`);
    }else if (path === "brandList"){
      setNavpath(path);
      navigate(`/brandManagement/brandList`);
    } else {
      setNavpath(path);
      navigate(`/brandManagement/brandDetailView/${brand_id}`);
    }
  };

  const removePlatform = () => {
    const { platform_id } = removePlatformModalDetailToggle;
    setPlatformDashboardMapping((prev) => {
      return prev?.filter(
        (platformDashboardMapping) =>
          platformDashboardMapping.platform_id !== platform_id
      );
    });
    setBrandPlatformMapping((prev) => {
      return {
        ...prev,
        platform_array: prev?.platform_array.filter(
          (platform) => platform.platform_id !== platform_id
        ),
      };
    });
    setRemovePlatformModalDetailToggle({
      toggle: false,
      platform_id: "",
      platform_logo_url:"",
      platform: "",
    });
    setSaveToggle(true);
    // fetchSuggestPlatform();
  };

  // On Clicking Discard Button in SaveChanges Modal cancelSaveChanges function will be called
  const cancelSaveChanges = () => {
    if (navpath === "brandDetailView") {
      navigate(`/brandManagement/brandDetailView/${brand_id}`);
    } else {
      navigate(`/brandManagement/brandList`);
    }
  };
    // Save Changes function for Save Changes Button in Save Changes PopUp Modal
  const savechanges = () => {
    onSaveClickHandler();
    setCancelToggle(false);
  };

  return (
    <div>
      <div
        className="px-10 pt-6"
        style={{
          height: "calc(100vh - 144px)",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row items-center">
            <span
              className="cursor-pointer"
              onClick={() => cancelToggleHandler("brandList")}
              // onClick={() => navigate("/brandManagement/brandList")}
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                color: BLACK.B_40,
              }}
            >
              Brand List
            </span>
            <span className="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.40003 7.99999L5.80003 5.39999C5.67781 5.27777 5.6167 5.12221 5.6167 4.93333C5.6167 4.74444 5.67781 4.58888 5.80003 4.46666C5.92225 4.34444 6.07781 4.28333 6.2667 4.28333C6.45559 4.28333 6.61114 4.34444 6.73337 4.46666L9.80003 7.53333C9.8667 7.59999 9.91392 7.67221 9.9417 7.74999C9.96948 7.82777 9.98337 7.9111 9.98337 7.99999C9.98337 8.08888 9.96948 8.17221 9.9417 8.24999C9.91392 8.32777 9.8667 8.39999 9.80003 8.46666L6.73337 11.5333C6.61114 11.6555 6.45559 11.7167 6.2667 11.7167C6.07781 11.7167 5.92225 11.6555 5.80003 11.5333C5.67781 11.4111 5.6167 11.2555 5.6167 11.0667C5.6167 10.8778 5.67781 10.7222 5.80003 10.6L8.40003 7.99999Z"
                  fill="#1C1C1C"
                  fill-opacity="0.4"
                />
              </svg>
            </span>
            <span
              className="cursor-pointer"
              onClick={() => cancelToggleHandler("brandDetailView")}

              // onClick={() =>
              //   navigate(`/brandManagement/brandDetailView/${brand_id}`)
              // }
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                color: BLACK.B_40,
              }}
            >
              Brand Details
            </span>
            <span className="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.40003 7.99999L5.80003 5.39999C5.67781 5.27777 5.6167 5.12221 5.6167 4.93333C5.6167 4.74444 5.67781 4.58888 5.80003 4.46666C5.92225 4.34444 6.07781 4.28333 6.2667 4.28333C6.45559 4.28333 6.61114 4.34444 6.73337 4.46666L9.80003 7.53333C9.8667 7.59999 9.91392 7.67221 9.9417 7.74999C9.96948 7.82777 9.98337 7.9111 9.98337 7.99999C9.98337 8.08888 9.96948 8.17221 9.9417 8.24999C9.91392 8.32777 9.8667 8.39999 9.80003 8.46666L6.73337 11.5333C6.61114 11.6555 6.45559 11.7167 6.2667 11.7167C6.07781 11.7167 5.92225 11.6555 5.80003 11.5333C5.67781 11.4111 5.6167 11.2555 5.6167 11.0667C5.6167 10.8778 5.67781 10.7222 5.80003 10.6L8.40003 7.99999Z"
                  fill="#1C1C1C"
                  fill-opacity="0.4"
                />
              </svg>
            </span>
            <span style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px" }}>
              Edit Details
            </span>
          </div>
        </div>

        {dataBrandPlatformMappingFetchingState === "LOADING" && (
          <div className="mt-6 w-fit" style={{ height: 320 }}>
            <Skeleton
              sx={{
                height: 320,
                borderRadius: 16,
                width: "calc(100% - 80px)",
                opacity: 0.5,
              }}
            />
          </div>
        )}
        {dataBrandPlatformMappingFetchingState === "SUCCESS" && (
          <div
            className="mt-6 p-6"
            style={{
              boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05)",
              borderRadius: 16,
            }}
          >
            <div className="flex flex-col">
              <div
                style={{ fontSize: 16, fontWeight: 700, lineHeight: "20px" }}
              >
                Basic Details
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: BLACK.B_40,
                }}
              >
                Review and adjust the basic information as necessary
              </div>
            </div>
            <div className="flex mt-6">
              <div className="w-full" style={{ marginRight: 60 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: BLACK.B_80,
                  }}
                >
                  Brand Name
                </div>
                <Input
                  placeholder="Brand Name"
                  value={brandPlatformMapping?.brand_name}
                  sx={{
                    "--Input-focusedThickness": "0px",

                    height: "52px",
                    border: `1px solid ${BLACK.B_5}`,
                    fontSize: 14,
                    fontWeight: 400,
                    lineHeight: "20px",
                    backgroundColor: WHITE.W_100,
                    boxShadow: "none",
                  }}
                  name="brand_name"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="w-full" style={{ marginRight: 60 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: BLACK.B_80,
                  }}
                >
                  Company Name
                </div>
                <Input
                  placeholder="Company Name"
                  value={brandPlatformMapping?.company_name}
                  sx={{
                    "--Input-focusedThickness": "0px",
                    height: "52px",
                    border: `1px solid ${BLACK.B_5}`,
                    fontSize: 14,
                    fontWeight: 400,
                    lineHeight: "20px",
                    backgroundColor: WHITE.W_100,
                    boxShadow: "none",
                  }}
                  name="company_name"
                  onChange={onChangeHandler}
                />
              </div>
              {brandPlatformMapping?.status && (
                <div className="w-full">
                  <div
                    className="mb-1"
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      lineHeight: "20px",
                      color: BLACK.B_80,
                    }}
                  >
                    Status
                  </div>
                  <Select
                    onChange={onSelectChangeHandler}
                    // placeholder="Select State"
                    defaultValue={brandPlatformMapping?.status}
                    name="status"
                    value={brandPlatformMapping?.status}
                    indicator={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                          fill="#1C1C1C"
                          fill-opacity="0.4"
                        />
                      </svg>
                    }
                    slotProps={{
                      listbox: {},
                    }}
                    sx={{
                      "--Input-focusedThickness": "0px",

                      height: "52px",
                      color: BLACK.B_80,
                      fontSize: 14,
                      fontWeight: 400,
                      lineHeight: "20px",
                      backgroundColor: WHITE.W_100,
                      boxShadow: "none",
                      border: `1px solid ${BLACK.B_5}`,
                      [`& .${selectClasses.indicator}`]: {
                        transition: "0.2s",
                        [`&.${selectClasses.expanded}`]: {
                          transform: "rotate(-180deg)",
                        },
                      },
                      ":hover": {
                        backgroundColor: WHITE.W_100,
                      },
                    }}
                  >
                    <Option value={"ACTIVE"}>Active</Option>
                    <Option value={"INACTIVE"}>Inactive</Option>
                  </Select>
                </div>
              )}
            </div>
            <div className="mt-6">
              <div
                className="mb-2"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: BLACK.B_80,
                }}
              >
                Platforms
              </div>
              <div className="flex">
                {brandPlatformMapping?.platform_array.map((platform, index) => {
                  let marginLeft = index === 0 ? 0 : 8;
                  return (
                    <div
                      key={platform?.platform_id}
                      className="flex flex-row items-center px-2  w-fit"
                      style={{
                        height: 28,
                        borderRadius: 4,
                        backgroundColor: BLACK.B_5,
                        marginLeft,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                          lineHeight: "18px",
                        }}
                      >
                        {platform?.platform}
                      </span>
                      <span
                        onClick={() => removePlatformToggle(platform, true)}
                        className="ml-2 cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M12.9422 7.94219L10.8836 10L12.9422 12.0578C13.0003 12.1159 13.0463 12.1848 13.0777 12.2607C13.1092 12.3366 13.1254 12.4179 13.1254 12.5C13.1254 12.5821 13.1092 12.6634 13.0777 12.7393C13.0463 12.8152 13.0003 12.8841 12.9422 12.9422C12.8841 13.0003 12.8152 13.0463 12.7393 13.0777C12.6634 13.1092 12.5821 13.1253 12.5 13.1253C12.4179 13.1253 12.3366 13.1092 12.2607 13.0777C12.1848 13.0463 12.1159 13.0003 12.0578 12.9422L10 10.8836L7.94219 12.9422C7.88412 13.0003 7.81518 13.0463 7.73931 13.0777C7.66344 13.1092 7.58213 13.1253 7.5 13.1253C7.41788 13.1253 7.33656 13.1092 7.26069 13.0777C7.18482 13.0463 7.11588 13.0003 7.05782 12.9422C6.99975 12.8841 6.95368 12.8152 6.92226 12.7393C6.89083 12.6634 6.87466 12.5821 6.87466 12.5C6.87466 12.4179 6.89083 12.3366 6.92226 12.2607C6.95368 12.1848 6.99975 12.1159 7.05782 12.0578L9.11641 10L7.05782 7.94219C6.94054 7.82491 6.87466 7.66585 6.87466 7.5C6.87466 7.33415 6.94054 7.17509 7.05782 7.05781C7.17509 6.94054 7.33415 6.87465 7.5 6.87465C7.66586 6.87465 7.82492 6.94054 7.94219 7.05781L10 9.11641L12.0578 7.05781C12.1159 6.99974 12.1848 6.95368 12.2607 6.92225C12.3366 6.89083 12.4179 6.87465 12.5 6.87465C12.5821 6.87465 12.6634 6.89083 12.7393 6.92225C12.8152 6.95368 12.8841 6.99974 12.9422 7.05781C13.0003 7.11588 13.0463 7.18482 13.0777 7.26069C13.1092 7.33656 13.1254 7.41788 13.1254 7.5C13.1254 7.58212 13.1092 7.66344 13.0777 7.73931C13.0463 7.81518 13.0003 7.88412 12.9422 7.94219ZM18.125 10C18.125 11.607 17.6485 13.1779 16.7557 14.514C15.8629 15.8502 14.594 16.8916 13.1093 17.5065C11.6247 18.1215 9.99099 18.2824 8.4149 17.9689C6.8388 17.6554 5.39106 16.8815 4.25476 15.7452C3.11846 14.6089 2.34463 13.1612 2.03112 11.5851C1.71762 10.009 1.87852 8.37535 2.49348 6.8907C3.10844 5.40605 4.14985 4.1371 5.486 3.24431C6.82214 2.35152 8.39303 1.875 10 1.875C12.1542 1.87727 14.2195 2.73403 15.7427 4.25727C17.266 5.78051 18.1227 7.84581 18.125 10ZM16.875 10C16.875 8.64025 16.4718 7.31104 15.7164 6.18045C14.9609 5.04987 13.8872 4.16868 12.631 3.64833C11.3747 3.12798 9.99238 2.99183 8.65876 3.2571C7.32514 3.52237 6.10013 4.17716 5.13864 5.13864C4.17716 6.10013 3.52238 7.32513 3.2571 8.65875C2.99183 9.99237 3.12798 11.3747 3.64833 12.6309C4.16868 13.8872 5.04987 14.9609 6.18046 15.7164C7.31105 16.4718 8.64026 16.875 10 16.875C11.8227 16.8729 13.5702 16.1479 14.8591 14.8591C16.1479 13.5702 16.8729 11.8227 16.875 10Z"
                            fill="#1C1C1C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      </span>
                    </div>
                  );
                })}
              </div>
              {platformlength > 0 && (
                <div
                onClick={() => setAddPlatformModalToggle(true)}
                className="flex items-center cursor-pointer w-fit"
                style={{ marginTop: 14 }}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.33325 8.66665H3.99992C3.81103 8.66665 3.6527 8.60276 3.52492 8.47498C3.39714 8.3472 3.33325 8.18887 3.33325 7.99998C3.33325 7.81109 3.39714 7.65276 3.52492 7.52498C3.6527 7.3972 3.81103 7.33331 3.99992 7.33331H7.33325V3.99998C7.33325 3.81109 7.39714 3.65276 7.52492 3.52498C7.6527 3.3972 7.81103 3.33331 7.99992 3.33331C8.18881 3.33331 8.34714 3.3972 8.47492 3.52498C8.6027 3.65276 8.66659 3.81109 8.66659 3.99998V7.33331H11.9999C12.1888 7.33331 12.3471 7.3972 12.4749 7.52498C12.6027 7.65276 12.6666 7.81109 12.6666 7.99998C12.6666 8.18887 12.6027 8.3472 12.4749 8.47498C12.3471 8.60276 12.1888 8.66665 11.9999 8.66665H8.66659V12C8.66659 12.1889 8.6027 12.3472 8.47492 12.475C8.34714 12.6028 8.18881 12.6666 7.99992 12.6666C7.81103 12.6666 7.6527 12.6028 7.52492 12.475C7.39714 12.3472 7.33325 12.1889 7.33325 12V8.66665Z"
                      fill="#1886FE"
                    />
                  </svg>
                </span>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    textDecoration: "underline",
                    color: PRIMARY.P_BLue,
                  }}
                >
                  Add Platforms
                </span>
              </div>)}
            </div>
          </div>
        )}

        {dataBrandPlatformMappingFetchingState === "ERROR" && (
          <div
            className="flex justify-center items-center  mt-6"
            style={{
              height: 132,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "20px",
              color: BLACK.B_40,
            }}
          >
            Unable to fetch brand data please refresh.
          </div>
        )}

        {dataPlatformDashboardMappingFetchingState === "LOADING" && (
          <div className="mt-6 w-fit" style={{ height: 320 }}>
            <Skeleton
              sx={{
                height: 320,
                borderRadius: 16,
                width: "calc(100% - 80px)",
                opacity: 0.5,
              }}
            />
          </div>
        )}

        {dataPlatformDashboardMappingFetchingState === "SUCCESS" &&
          platformDashboardMapping?.map((platformDashboardMapping, index) => {
            return (
              <PlatformDashboardMappingEdit
                key={platformDashboardMapping.platform_id}
                platformDashboardMapping={platformDashboardMapping}
                addNewDashboard={addNewDashboard}
                editDashboard={editDashboard}
                removePlatformToggle={removePlatformToggle}
                removeDashboard={removeDashboard}
                fetchSuggestPlatform={fetchSuggestPlatform}
              />
            );
          })}

        {dataPlatformDashboardMappingFetchingState === "EMPTY" && (
          <div
            className="flex justify-center items-center  mt-6"
            style={{
              height: 132,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "20px",
              color: BLACK.B_40,
            }}
          >
            Please map the platforms with brands.
          </div>
        )}
      </div>
      {addPlatformModalToggle && (
        <BrandPlatformEditModal
          brandPlatformMapping={brandPlatformMapping}
          setAddPlatformModalToggle={setAddPlatformModalToggle}
          addPlatform={addPlatform}
        />
      )}

      <div
        className="flex flex-row items-center justify-end px-10"
        style={{
          height: 72,
          boxShadow: " 0px -4px 40px 4px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Button
          color="neutral"
          sx={{
            height: "40px",
            width: "220px",
            backgroundColor: BLACK.B_5,
            color: BLACK.B_100,
            ":hover": {
              backgroundColor: BLACK.B_20,
            },
          }}
          onClick={() => cancelToggleHandler("")}
          // onClick={onCancelClickHandler}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          onClick={onSaveClickHandler}
          disabled={!saveToggle  && true}
          sx={{
            height: "40px",
            width: "220px",
            backgroundColor: PRIMARY.P_BLue,
            marginLeft: "16px",
          }}
        >
          Save
        </Button>
      </div>

      {removePlatformModalDetailToggle?.toggle && (
        <RemovePlatformModal
          cancelRemovePlatformToggle={cancelRemovePlatformToggle}
          removePlatform={removePlatform}
          platform={removePlatformModalDetailToggle.platform}
        />
      )}
      {removeDashboardModalDetailToggle?.toggle && (
        <RemoveDashboardModal
          removeDashboard={removeDashboardFromState}
          cancelRemoveDashboardToggle={cancelRemoveDashboardToggle}
          dashboardType={removeDashboardModalDetailToggle.dashboard_type}
        />
      )}
      {cancelToggle && (
      <SaveChangesModal
        cancelSaveChangesToggle={cancelSaveChanges}
        savechanges={savechanges}
        loading={loading}
      />
    )}
    </div>
  );
};

export default BrandDetailEdit;
